export const Login = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 7V4C14 3.44772 14.4477 3 15 3H27C27.5523 3 28 3.44772 28 4V28C28 28.5523 27.5523 29 27 29H15C14.4477 29 14 28.5523 14 28V25" stroke="currentColor" stroke-width="2"/>
<path d="M5 16H21" stroke="currentColor" stroke-width="2"/>
<path d="M16.3086 10.6994L21.6006 15.9999L16.284 21.2938" stroke="currentColor" stroke-width="2"/>
</svg>`;
